import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { TemplateLibraryItem } from '../TemplateLibrary/TemplateLibrary.component';
import './TemplateCard.component.scss';
import React from 'react';

interface TemplateCardProps {
  temp: TemplateLibraryItem;
  onChange: (temp: TemplateLibraryItem) => void;
};

const TemplateCard = ({ temp, onChange }: TemplateCardProps) => {
  const {
    check,
    templateName
  } = temp;
  return (
    <div className="template-card" onClick={() => onChange(temp)}>
      <button className="template-card__button" data-testid="template-card-button">
        {check ? (
          <CheckCircleIcon
            style={{
              fontSize: 20,
              color: '#5D54C0',
            }}
          />
        ) : (
          <CheckCircleOutlineOutlinedIcon
            style={{
              fontSize: 20,
              color: '#9997AF',
            }}
          />
        )}
      </button>
      <div className="template-card__content">
        <div className="template-card__content__title" data-testid="template-card-title">
          {templateName}
        </div>
      </div>
    </div >
  );
}

export default TemplateCard;
